import {
    ITopicHeaders,
    MessageBroker,
    PostLoginActionNameEnum,
    UiChannel,
} from '@sparkware/uc-sdk-core';
import Container from 'typedi';
import { TypeUtils } from '../../../../Modules/Utils/TypeUtils';
import { StorageItemEnum } from '../../../models/enums/storage-enums';
import { SessionSimpleStoreService } from '../../storage/implementations/simple-store';
import DialogType from '../../ui/enums/DialogType';
import {
    IActivityHistoryPostLoginOptions,
    IPostLoginActionsState,
} from '../models/IPostLoginActionsState';
import { PostLoginActionBase } from './post-login-action-base';

const MB_HEADER: ITopicHeaders = { publisher: 'OpenActivityHistoryPostLoginAction' };

export class OpenActivityHistoryPostLoginAction extends PostLoginActionBase {
    private _sessionSimpleStoreService: SessionSimpleStoreService;
    private _uiChannel: UiChannel;

    constructor(state: IPostLoginActionsState) {
        super(PostLoginActionNameEnum.ActivityHistory, 'OpenActivityHistoryPostLoginAction', state);

        this._sessionSimpleStoreService = Container.get(SessionSimpleStoreService);
        this._uiChannel = MessageBroker.getInstance().ui;
    }

    protected override canExecute = (
        options?: IActivityHistoryPostLoginOptions,
    ): Promise<boolean> => {
        const isDisabled = options?.disabled || false;
        const isActivityHistoryProcessed = TypeUtils.toBoolean(
            this._sessionSimpleStoreService.get(
                StorageItemEnum.IsPostLoginActivityHistoryProcessed,
            ),
        );

        const canExecute = !isActivityHistoryProcessed && !isDisabled;

        return Promise.resolve(canExecute);
    };

    protected override doAction = async (): Promise<boolean> => {
        this.clearOptions();

        this._sessionSimpleStoreService.set(
            StorageItemEnum.IsPostLoginActivityHistoryProcessed,
            true,
        );

        const dialogOptions = {
            closeTimeout: 15000,
            onClose: this.completeAction,
        };

        this._uiChannel.topics.DialogShow.publish(MB_HEADER, {
            dialogType: DialogType.ActivityHistory,
            options: dialogOptions,
        });

        return false;
    };
}
